function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step)
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step)
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle("disabled", value >= max);
      }
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image"
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image"
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li"
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple"
      );
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      if (image_container) {
        image_container.addEventListener("touchstart", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchmove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchend", mouseleave, {
          passive: true,
        });
        image_container.addEventListener("mouseenter", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mousemove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mouseleave", mouseleave, {
          passive: true,
        });
      }
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.getAttribute("srcset") || image.dataset.srcset || "" : "",
        active = swatches.querySelector(".product-card-swatch.active");

      swatch_list.forEach((swatch, index) => {
        swatch.addEventListener("mouseover", function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }

          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData(this.form);

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").classList.add("active");
        document.body.classList.add("open-cart");
        document.body.classList.add("open-cc");
        if (
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
        ) {
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
        dispatchCustomEvent("cart-drawer:open");
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector(".header-section"),
      header_main = document.getElementById("header"),
      menu = document.getElementById("mobile-menu"),
      toggle = document.querySelector(".mobile-toggle-wrapper"),
      btnBack = document.querySelector(".header-back-btn"),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE" && toggle) {
          toggle.removeAttribute("open");
          toggle.classList.remove("active");
        }
      }
    });

    if (toggle) {
      toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
        setAnnouncementHeight(header);
        if (toggle.classList.contains("active")) {
          e.preventDefault();
          document.body.classList.remove("overflow-hidden");
          toggle.classList.remove("active");
          this.closeAnimation(toggle);
        } else {
          document.body.classList.add("overflow-hidden");
          setTimeout(() => {
            toggle.classList.add("active");
          });
        }
        window.dispatchEvent(new Event("resize.resize-select"));
      });
    }

    if (btnBack) {
      btnBack.addEventListener("click", (e) => {
        if (history.length > 1) {
          history.back();
        } else {
          window.location.href = "/";
        }
        e.preventDefault();
      });
    }

    // Mobile Menu offset
    window.addEventListener(
      "scroll",
      function () {
        setHeaderOffset(header);
        setHeaderHeight(header_main);
        // Sticky Header Class
        if (header_main.classList.contains("header-sticky--active")) {
          document.body.classList.add("header-sticky");

          let offset =
            parseInt(header_main.getBoundingClientRect().top, 10) +
            document.documentElement.scrollTop;

          header_main.classList.toggle(
            "is-sticky",
            window.scrollY >= offset && window.scrollY > 0
          );
        }
      },
      {
        passive: true,
      }
    );
    window.dispatchEvent(new Event("scroll"));

    if (document.getElementById("shopify-section-announcement-bar")) {
      const a_bar = document.getElementById("shopify-section-announcement-bar");
      window.addEventListener(
        "resize",
        function () {
          setAnnouncementHeight(a_bar);
        },
        {
          passive: true,
        }
      );
      window.dispatchEvent(new Event("resize"));
    }
    // Buttons.
    menu?.querySelectorAll("summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
    menu?.querySelectorAll("button")
      .forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty(
      "--announcement-height",
      h + "px"
    );
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty("--header-height", h + "px");
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".link-container");
    const isOpen = detailsElement.hasAttribute("open");

    setTimeout(() => {
      detailsElement.classList.add("menu-opening");
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
          details.classList.remove("submenu-open");
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu"
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
      let cc = document.querySelector(".click-capture");

      // Add functionality to buttons
      this.addEventListener("click", (e) => this.close_panel(e));
      document.addEventListener("panel:close", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener("click", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest(".side-panel");

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains("product-drawer")) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains("cart-drawer")) {
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                document.body.classList.remove("open-cc");
                document.body.classList.remove("open-cart");
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove("active");
        if (!document.body.classList.contains("open-cart")) {
          document.body.classList.remove("open-cc");
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (!document.body.classList.contains("open-cart")) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById("Cart-Drawer");

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById("cart-drawer-toggle"),
      quantities = this.container.querySelectorAll(".quantity input");

    // Add functionality to buttons
    button.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.add("open-cc");
      document.body.classList.add("open-cart");
      this.container.classList.add("active");
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector(".product-recommendations--full")) {
          this.container
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
      });
      dispatchCustomEvent("cart-drawer:open");
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (!this.container.contains(event.target)) return;
    if (event.target.classList.contains("qty")) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    if (this.removeProductHandler) return;
    this.removeProductHandler = (event) => {
      const remove = event.target.closest(".remove");
      if (!remove || !this.container.contains(remove)) return;
      event.preventDefault();
      this.updateQuantity(remove.dataset.index, 0);
    };
    this.container.addEventListener("click", this.removeProductHandler);
  }
  getSectionsToRender() {
    return [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector("#CartDrawerTerms"),
      checkout_button = this.container.querySelector(".button.checkout");

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener("click", function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById("order-note-toggle");

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener("click", (event) => {
      notes_toggle.nextElementSibling.classList.add("active");
    });
    notes_toggle.nextElementSibling
      .querySelectorAll(".button, .order-note-toggle__content-overlay")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          notes_toggle.nextElementSibling.classList.remove("active");
          this.saveNotes();
        });
      });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById("mini-cart__notes").value,
      }),
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector(".free-shipping");

    if (free_shipping) {
      let amount_text = free_shipping.querySelector(
        ".free-shipping--text span"
      );
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(
        parseInt(free_shipping.dataset.minimum, 10) *
          (Shopify.currency.rate || 1)
      );
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format =
              window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty("--percentage", percentage);
    }
  }
  updateQuantity(line, quantity) {
    const container = this.container.querySelector(`#CartDrawerItem-${line}`);
    const itemKey = container?.querySelector(".quantity")?.dataset.id;
    const newQuantity = Number(quantity);
    if (
      this.isUpdating ||
      !itemKey ||
      quantity === "" ||
      !Number.isInteger(newQuantity) ||
      newQuantity < 0
    ) return;
    this.isUpdating = true;
    container.classList.add("thb-loading");
    const body = JSON.stringify({
      id: itemKey,
      quantity: newQuantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    dispatchCustomEvent("line-item:change:start", {
      quantity: quantity,
    });
    if (this.container.querySelector(".product-recommendations--full")) {
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active");
    }
    return fetch(`${theme.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) return;

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent("line-item:change:end", {
          quantity: quantity,
          cart: parsedState,
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container
            .querySelector(`#CartDrawerItem-${line}`)
            .classList.remove("thb-loading");
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.isUpdating = false;
        container.classList.remove("thb-loading");
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    // Iframes from page content load only while the modal is open (snippets/product-information.liquid).
    this.querySelectorAll("iframe[data-modal-src]").forEach((iframe) => {
      if (iframe.getAttribute("src") !== iframe.dataset.modalSrc) {
        iframe.setAttribute("src", iframe.dataset.modalSrc);
      }
    });
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    // Unloading also stops a video that the pause messages below cannot reach.
    this.querySelectorAll("iframe[data-modal-src]").forEach((iframe) =>
      iframe.setAttribute("src", "about:blank")
    );
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-localization-forms")
      .forEach((localization) => {
        localization.addEventListener("change", (e) => {
          localization.querySelector("form").submit();
        });
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-widget-title.collapsible")
      .forEach((button) => {
        button.addEventListener("click", (e) => {
          button.classList.toggle("active");
        });
      });
  }
}

function getThemeAssetUrl(url) {
  const assetUrl = new URL(url, document.baseURI);
  if (assetUrl.pathname.startsWith("/cdn/shop/")) {
    return `${assetUrl.pathname}${assetUrl.search}`;
  }
  return assetUrl.href;
}

const THEME_RESOURCE_TIMEOUT = 10000;

function waitForResource(element, timeout) {
  return new Promise((resolve, reject) => {
    const url = element.src || element.href;
    const cleanup = () => {
      clearTimeout(timer);
      element.removeEventListener("load", onLoad);
      element.removeEventListener("error", onError);
    };
    const onLoad = () => {
      cleanup();
      resolve();
    };
    const onError = () => {
      cleanup();
      reject(new Error(`Failed to load ${url}`));
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error(`Timed out loading ${url}`));
    }, timeout);

    element.addEventListener("load", onLoad);
    element.addEventListener("error", onError);
  });
}

function loadProductScript(timeout = THEME_RESOURCE_TIMEOUT) {
  if (customElements.get("product-form")) return Promise.resolve();
  if (window.productScriptPromise) return window.productScriptPromise;

  const script = document.createElement("script");
  script.src = getThemeAssetUrl(theme.routes.product_script_url);
  script.async = true;

  window.productScriptPromise = waitForResource(script, timeout).catch(
    (error) => {
      script.remove();
      window.productScriptPromise = null;
      throw error;
    }
  );
  document.head.appendChild(script);

  return window.productScriptPromise;
}

function loadStylesheet(url, timeout = THEME_RESOURCE_TIMEOUT) {
  const href = new URL(getThemeAssetUrl(url), document.baseURI).href;
  const existing = Array.from(
    document.querySelectorAll('link[rel~="stylesheet"]')
  ).find(
    (link) => link.href === href && link.dataset.themeResourceFailed !== "true"
  );

  if (existing && existing.sheet) return Promise.resolve();

  const link = existing || document.createElement("link");
  const loaded = waitForResource(link, timeout).catch((error) => {
    // A link from the page may still finish later, so keep it and only skip it on retry.
    if (existing) {
      link.dataset.themeResourceFailed = "true";
    } else {
      link.remove();
    }
    throw error;
  });

  if (!existing) {
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }

  return loaded;
}

function loadProductResources() {
  if (!window.productStylesPromise) {
    window.productStylesPromise = Promise.all([
      loadStylesheet(theme.routes.product_style_url),
      loadStylesheet(theme.routes.subscription_details_style_url),
    ]).catch((error) => {
      window.productStylesPromise = null;
      throw error;
    });
  }

  return Promise.all([loadProductScript(), window.productStylesPromise]);
}

const LITE_YOUTUBE_SELECTOR = ".lite-youtube, .lite-youtube-dev, lite-youtube";
const LITE_YOUTUBE_RETRY_LIMIT = 2;

function containsLiteYoutube(root) {
  return Boolean(
    root?.matches?.(LITE_YOUTUBE_SELECTOR) ||
      root?.querySelector?.(LITE_YOUTUBE_SELECTOR),
  );
}

function loadLiteYoutubeScript(attempt = 0) {
  if (window.LiteYTEmbedDiv?.init) return Promise.resolve();
  if (window.liteYoutubeScriptPromise) return window.liteYoutubeScriptPromise;

  const script = document.createElement("script");
  const scriptUrl = new URL(
    getThemeAssetUrl(theme.routes.lite_youtube_script_url),
    document.baseURI,
  );
  if (attempt) scriptUrl.searchParams.set("lite_youtube_retry", String(attempt));
  script.type = "module";
  script.src = getThemeAssetUrl(scriptUrl.href);
  script.dataset.liteYoutubeLoader = "true";

  const request = waitForResource(script, THEME_RESOURCE_TIMEOUT).then(() => {
    if (!window.LiteYTEmbedDiv?.init) {
      throw new Error(`Loaded ${script.src} without initializing LiteYTEmbedDiv`);
    }
  });
  const promise = request.catch((error) => {
    script.remove();
    if (window.liteYoutubeScript === script) window.liteYoutubeScript = null;
    if (attempt >= LITE_YOUTUBE_RETRY_LIMIT) {
      if (window.liteYoutubeScriptPromise === promise) window.liteYoutubeScriptPromise = null;
      throw error;
    }

    return new Promise((resolve) => setTimeout(resolve, 250 * (attempt + 1))).then(() => {
      if (window.liteYoutubeScriptPromise === promise) window.liteYoutubeScriptPromise = null;
      return loadLiteYoutubeScript(attempt + 1);
    });
  });

  window.liteYoutubeScript = script;
  window.liteYoutubeScriptPromise = promise;
  document.head.appendChild(script);
  return promise;
}

function loadLiteYoutube(root = document) {
  if (!containsLiteYoutube(root)) return Promise.resolve();
  if (window.LiteYTEmbedDiv?.init) {
    window.LiteYTEmbedDiv.init(root);
    return Promise.resolve();
  }
  if (!theme.routes.lite_youtube_script_url) return Promise.resolve();

  return loadLiteYoutubeScript().then(() => window.LiteYTEmbedDiv.init(root));
}

function observeLiteYoutube() {
  if (window.liteYoutubeObserver || !document.documentElement) return;

  window.liteYoutubeObserver = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE || !containsLiteYoutube(node)) return;
        loadLiteYoutube(node).catch((error) => console.error(error));
      });
    });
  });
  window.liteYoutubeObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

// No page renders the recipe download modal. It is requested the first time a visitor reaches for a
// download button, so it also works for buttons in section groups, filtered results and the theme editor.
const RECIPE_DOWNLOAD_TRIGGER = "[data-recipe-download]";

function loadRecipeDownloadModal() {
  const rendered = document.getElementById("PopupModal-recipe");
  if (rendered) return Promise.resolve(rendered);
  if (window.recipeDownloadModalPromise) return window.recipeDownloadModalPromise;

  // The current page's context keeps the signup source URL that klaviyo-scripts reports.
  const url = `${window.location.pathname}?section_id=recipe-download-modal`;
  window.recipeDownloadModalPromise = fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to load ${url}: ${response.status}`);
      return response.text();
    })
    .then(async (html) => {
      const section = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("shopify-section-recipe-download-modal");
      const modal = section && section.querySelector("#PopupModal-recipe");
      if (!modal) throw new Error(`${url} did not return the recipe download modal`);

      // Wait for the modal's styles so that it never opens unstyled. It still opens if they fail.
      await Promise.allSettled(
        Array.from(section.querySelectorAll('link[rel="stylesheet"]'), (link) => {
          link.remove();
          return loadStylesheet(link.getAttribute("href"));
        })
      );

      const parsedScripts = Array.from(section.querySelectorAll("script"));
      document.body.appendChild(section);
      // Scripts parsed from a string never run, so replace them with live copies.
      parsedScripts.forEach((parsed) => {
        const script = document.createElement("script");
        Array.from(parsed.attributes).forEach(({ name, value }) => script.setAttribute(name, value));
        script.textContent = parsed.textContent;
        parsed.replaceWith(script);
      });
      return modal;
    })
    .catch((error) => {
      window.recipeDownloadModalPromise = null;
      throw error;
    });

  return window.recipeDownloadModalPromise;
}

document.addEventListener("click", (event) => {
  const button = event.target.closest?.(RECIPE_DOWNLOAD_TRIGGER);
  if (!button) return;
  event.preventDefault();

  loadRecipeDownloadModal()
    .then((modal) => {
      modal.dispatchEvent(new CustomEvent("recipe-download:open", { detail: { button } }));
      modal.show(button);
    })
    .catch((error) => console.error(error));
});

// Pointing at or focusing a button starts the request, so the modal is usually ready by the click.
// A failed early request is retried, and reported, by the click.
["pointerover", "focusin"].forEach((type) => {
  document.addEventListener(type, (event) => {
    if (!event.target.closest?.(RECIPE_DOWNLOAD_TRIGGER)) return;
    loadRecipeDownloadModal().catch(() => {});
  });
});

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      if (this.hasAttribute("disabled")) {
        this.setAttribute("aria-disabled", "true");
        this.tabIndex = -1;
      } else {
        this.setAttribute("role", "button");
        this.setAttribute("aria-haspopup", "dialog");
        this.setAttribute("aria-controls", "Product-Drawer");
        this.setAttribute("aria-expanded", "false");
        this.tabIndex = 0;
        if (!this.hasAttribute("aria-label")) {
          this.setAttribute("aria-label", this.textContent.trim() || "Quick view");
        }
      }

      this.addEventListener("click", this.setupEventListener.bind(this));
      this.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.click();
        }
      });
    }
    setupEventListener(e) {
      e.preventDefault();
      if (this.hasAttribute("disabled") || this.getAttribute("aria-disabled") === "true") {
        return;
      }
      let productHandle = this.dataset.productHandle,
        productUrl = `${theme.routes.root_url}/products/${productHandle}`;

      // remove double `/` in case shop might have /en or language in URL
      productUrl = productUrl.replace("//", "/");
      const href = `${productUrl}?view=quick-view`;
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      Promise.all([
        fetch(href, {
          method: "GET",
        }),
        loadProductResources(),
      ])
        .then(([response]) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch((error) => {
          this.classList.remove("loading");
          console.error(error);
          // Quick view is an enhancement; the product page still works without it.
          this.openProductPage(productUrl);
        });
    }
    openProductPage(url) {
      window.location.assign(url);
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");
        this.drawer._quickViewTrigger = this;
        this.setAttribute("aria-expanded", "true");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          this.drawer
            .querySelector(".product-quick-images--container")
            .classList.add("active");
        });
        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

if (document.querySelector("product-form, variant-selects, variant-radios")) {
  loadProductResources().catch((error) => console.error(error));
}
loadLiteYoutube().catch((error) => console.error(error));
observeLiteYoutube();

document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector("product-form, variant-selects, variant-radios")) {
    loadProductResources().catch((error) => console.error(error));
  }
  loadLiteYoutube(event.target).catch((error) => console.error(error));
});

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel"
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined"
      ) {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector("summary").addEventListener("click", (e) =>
            this.onClick(e)
          );
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector("summary").offsetHeight,
        content_height = this.querySelector(
          ".collapsible__content"
        ).offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: "sine.inOut",
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = "hidden";
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = "";
        },
      });

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: "height",
        },
        {
          duration: 0.6,
          height: final_height,
          clearProps: "height",
        }
      );

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
      setTimeout(
        () =>
          this.details.scrollIntoView({ behavior: "smooth", block: "start" }),
        300
      );
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Localization !== "undefined") {
    new Localization();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
  if (typeof Header !== "undefined") {
    new Header();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});

//popup youtube video
(function () {
  function createPopup() {
    const popup = document.createElement("div");
    popup.id = "media-popup";
    const popupIframe = document.createElement("iframe");
    popupIframe.setAttribute("src", "");
    popupIframe.setAttribute("allowfullscreen", "");
    popupIframe.setAttribute("frameborder", "0");
    document.body.prepend(popup);
    popup.appendChild(popupIframe);
  }

  createPopup();

  const buttons = document.querySelectorAll("[popup-youtube]");
  const modal = document.querySelector("#media-popup");
  const iframe = document.querySelector("#media-popup iframe");

  modal.onclick = function () {
    document.body.classList.toggle("show-popup");
    iframe.src = "";
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const videoId = button.getAttribute("popup-youtube");
      document.body.classList.toggle("show-popup");
      iframe.src = "https://www.youtube.com/embed/" + videoId;
    });
  });

  //legacy code
  const buttons_legacy = document.querySelectorAll("[data-media]");
  buttons_legacy.forEach((button) => {
    button.addEventListener("click", () => {
      const videoId = button.getAttribute("data-media");
      document.body.classList.toggle("show-popup");
      iframe.src = videoId;
    });
  });
  //end legacy code
})();

//table of contents
const tableContentContainer = document.querySelector(".tablecontents:not(.article-toc)");
const tableContentButton = document.querySelector(".tablecontentscaption");
if (tableContentContainer && tableContentButton) {
  tableContentButton.onclick = function () {
    tableContentContainer.classList.toggle("collapsed");
  };
}

//External links
function secureLinks(root) {
  const links = root.matches?.("a[href]") ? [root] : root.querySelectorAll?.("a[href]") || [];
  links.forEach((link) => {
    if (!/^https?:$/.test(link.protocol)) return;
    if (link.hostname !== window.location.hostname && link.hostname !== "dreamofjapan.com") {
      if (link.target !== "_blank") link.target = "_blank";
      link.relList.add("noreferrer");
    }
    if (link.target === "_blank" && !link.relList.contains("noopener")) {
      link.relList.add("noopener");
    }
  });
}
secureLinks(document);
new MutationObserver((records) => {
  records.forEach((record) => {
    if (record.type === "attributes") secureLinks(record.target);
    else record.addedNodes.forEach((node) => secureLinks(node));
  });
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["href", "target"] });
